
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import moment from 'moment';
import itemMixin from '@/minix/itemMixin';

const { report } = api;
@Component({ components: { DateRange } })
export default class SwapOutPointReport extends Mixins(Vue.extend(itemMixin)) {
  private data = {
    data: [],
    totalPoints: 0,
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  merchantList: Merchant[] = [];

  private headers = [
    { text: '換出時間', value: 'createdOn', width: 160 },
    { text: '點數換出訂單編號', value: 'transactionId', width: 160 },
    { text: '外部ID', value: 'userIdPublic', width: 100 },
    { text: '姓名', value: 'fullName', width: 100 },
    { text: '換出供應商', value: 'merchantName', width: 120 },
    { text: '換出數量', value: 'quantity', width: 100 },
    { text: '換出手續費', value: 'serviceFee', width: 120 },
    { text: '總點數兌換量', value: 'income', width: 120 },
    { text: '換出商品名稱', value: 'productName', width: 120 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get totalPoints() {
    return this.data.totalPoints;
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private get merchantSelectOptions() {
    const mcId = this.filter.merchantCategoryId;
    return this.merchantList
      .filter((m: any) => !mcId || mcId === m.categoryId)
      .map((m: any) => ({
        text: m.merchantName,
        value: m.merchantId,
      }));
  }

  private filter = {
    transactionId: this.$route.query.transactionId || undefined,
    userIdPublic: this.$route.query.userIdPublic || undefined,
    fullName: this.$route.query.fullName || undefined,
    merchantCategoryId: Util.isNullOrUndefined(
      this.$route.query.merchantCategoryId,
    )
      ? undefined
      : this.$route.query.merchantCategoryId,
    merchantId: Util.isNullOrUndefined(this.$route.query.merchantId)
      ? undefined
      : +this.$route.query.merchantId,
    startDate: this.$route.query.startDate === undefined ? this.getToday() : this.$route.query.startDate,
    endDate: this.$route.query.endDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getToday() {
    return moment().format('yyyy-MM-DD');
  }

  private async updatePage(page: number) {
    await this.query(`${this.pager.pageNo = page}`);
  }

  private async query(page: string) {
    const pageNo = (typeof page === 'string' ? page : null) || `${this.pager.pageNo = 1}`;
    const query = {
      ...this.filter,
      merchantId: this.filter.merchantId
        ? `${this.filter.merchantId}`
        : undefined,
      pageSize: `${this.pager.pageSize}`,
      pageNo,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      merchantCategoryId: undefined,
      merchantId: undefined,
      transactionId: undefined,
      userIdPublic: undefined,
      fullName: undefined,
      startDate: this.getToday(),
      endDate: undefined,
    };
    this.pager = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query('1');
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const filter = { ...this.filter };
    const { status, data } = await report.exportSwapOutPoint(filter);
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '行銷報表管理-換出點數.txt');
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.swapOutPoint(filter);
    if (status === 1) {
      this.data = data;
    }
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: SwapOutPointReport) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
